import React, { Component } from "react";
import FD from "../../RestAPI/fetchData";
import "./VideoLessons.css";
import App_data from "../../config/App_data";
import EASubscriptionCheck from "../../RestAPI/EASubscription";
import PartnerEASubscriptionCheck from "../../RestAPI/PartnerSubscription/EASubscription";
import language from "../../../assets/languages/language";
import ModalComponent from "../../Common/Modal";
import AlertMessage from "../../config/alertMessage";
import AppRoutes from "../../config/AppRoutes";
import ChatperwiseReadingData from "./ChatperwiseReadingData";
import Loader from "../../../common/loader";
import {autorun} from "mobx";
import userStore from "../../../store/userStore";
/* eslint-disable*/
class GMATVideoLessons extends Component {
  constructor(props) {
    window.scrollTo(0, 0);
    super(props);
    var messageTitle_cfa = `<i class="icon-info icons font-2xl d-block "></i>`;
    this.state = {
      alert_status: false,
      MessageTitle: messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_gmat,
      chapters: [],
      allChapters: [],
      token: "",
      idname: "",
      ValidToken: false,
      chapter_id: "",
      offset: 0,
      limit: 10,
      Allchapters: [],
      itemData: [],
      subscription_details: "",
      subscription_details_for_isActive: "",
      showFreePremium: "",
      selectedmenu: "ea",
      exams: [],
      cfaUnlimitedPackage: "",
      cfaUnlimitedActiveExam: "",
      lastRecord: "",
      lastAttempt: false,
      user_city: "",
      user_country: "",
      user_ip: "",
      user_state: "",
      user_continent: "",
    };
  }

  slider;
  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert = () => {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  };

  goPremium = () => {
    this.context.router.push({
      pathname: "/Subscribe/",
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  _getReadings = async (chapter, e) => {
    var chap = chapter.chapter_no;
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      chapter_id: chap,
    };
    FD.callAPI(
      App_data.backend_api + "/ea_question_bank/getEAVideosChapterwise",
      data
    ).then(async (resp) => {
      if (resp.success) {
        if (this.state.showFreePremium === true) {
          this.toggleAlert();
        } else if (this.state.showFreePremium === false) {
          this.context.router.push({
            pathname: AppRoutes.EA_VIDEO_DISPLAY.replace(
              ":id",
              resp.cfavchapterfirst.id
            )
              .replace(":showFreePremium", this.state.showFreePremium ? 0 : 1)
              .replace(":type", chapter.chapter_id === 0 ? 0 : 1)
              .replace(":chapter_id", resp.cfavchapterfirst.chapter_id)
              .replace(":index", 0),
          });
        }
      } else {
      }
    });
  };

  iframe = {
    padding: 10,
  };

  async componentDidUpdate() {}

  async componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem("localstorageval"));
    this.setState({ idname: storage_session["idname"] });
    this.setState({ token: storage_session["token"] });
    const data = {
      token: storage_session["token"],
      idname: storage_session["idname"],
    };
    // await FD.callAPI(App_data.backend_api + "/user/getProfileInfo", data).then(async (resp) => {
     this.dispose = autorun(async () => {
       const resp = userStore;

       if(resp == null || resp.profileInfo == null) return;

        if (resp.profileInfo.role === "partner") {
          if (
            resp.profileInfo.exam_selected === "" &&
            resp.profileInfo.exam_package === ""
          ) {
            this.setState({
              showFreePremium: true,
            });
          } else {
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });

            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            await FD.callAPI(
              App_data.backend_api + "/checkout_v1/getExamsbyUser",
              dataset
            ).then(async (resp_exam) => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await PartnerEASubscriptionCheck.checkEAVideosSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
              }
            });
          }
        } else {
          if (
            resp.profileInfo.exam_selected === "" &&
            resp.profileInfo.cfaUnlimitedPackage == "" &&
            resp.profileInfo.cfaUnlimitedActiveExam == ""
          ) {
            console.log(
              "if working",
              resp.profileInfo.exam_selected === "" &&
                resp.profileInfo.cfaUnlimitedPackage == "" &&
                resp.profileInfo.cfaUnlimitedActiveExam == ""
            );
            this.setState({
              showFreePremium: true,
            });
          } else {
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            await FD.callAPI(
              App_data.backend_api + "/checkout_v1/getExamsbyUser",
              dataset
            ).then((resp_exam) => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = EASubscriptionCheck.checkEAVideosSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam
                );
                // console.log(isInArray_var);
                if (isInArray_var) {
                  // console.log('IF WORKING')
                  this.setState({ showFreePremium: false });
                } else {
                  // console.log('ELSE WORKING')
                  this.setState({ showFreePremium: true });
                }
              } else {
                // console.log('fail');
              }
            });
          }
        }
      }
    );

    var dataExam = {
      token: storage_session["token"],
      idname: storage_session["idname"],
    };
    FD.callAPI(App_data.backend_api + "/checkout_v1/getExams", dataExam).then(
      (resp) => {
        if (resp.success) {
          // console.log(resp);
          // console.log(resp.exams[0])
          this.setState({ ValidToken: true });
          this.setState({ exams: resp.exams[0] });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      }
    );

    var data_data = {
      token: storage_session["token"],
      idname: storage_session["idname"],
    };

    await FD.callAPI(
      App_data.backend_api + "/ea_question_bank/getEAVideos",
      data_data
    ).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({
          chapters: resp.cfavideo,
        });
      } else {
        this.setState({ ValidToken: false });
      }
      // return resp;
    });
    var chapter = this.state.chapters.map((val) => {
      if (val.Countvideos !== 0) {
        return val;
      }
    });

    var data_data = {
      token: storage_session["token"],
      idname: storage_session["idname"],
    };
    await FD.callAPI(
      App_data.backend_api + "/ea_question_bank/getlastViewedVideo",
      data_data
    ).then((response) => {
      if (response.success) {
        this.setState({
          lastRecord: response.data,
          lastAttempt: true,
        });
      }
    });
  }

  goToVideo = async () => {
    const { lastRecord, lastAttempt } = this.state;
    if (lastAttempt) {
      this.context.router.push({
        pathname: AppRoutes.EA_VIDEO_DISPLAY.replace(
          ":id",
          lastRecord.ea_video.id
        )
          .replace(":showFreePremium", this.state.showFreePremium ? 0 : 1)
          .replace(":type", lastRecord.ea_video.chapter_id === 0 ? 0 : 1)
          .replace(":chapter_id", lastRecord.ea_video.chapter_id)
          .replace(":index", lastRecord.videoIndex),
      });
    }
  };
  render() {
    const { lastAttempt } = this.state;
    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };
    let chapters = this.state.chapters;
    let exam = this.state.exams;
    console.log(this.state.chapters);
    let data = "";
    if (this.state.chapters.length) {
      data = chapters.map((item, index) => {
        console.log("===========> chapter for video" , item)
        // if (item.Countvideos !== 0) {
        //   let videoTitle;
        //   if (item.chapter_no === 1) {
        //     videoTitle = "Exam & Preparation Overview";
        //   } else if (item.chapter_no === 2) {
        //     videoTitle = "Integrated Reasoning";
        //   } else if (item.chapter_no === 3) {
        //     videoTitle = "Verbal Reasoning";
        //   } else if (item.chapter_no === 4) {
        //     videoTitle = "Quantitative Reasoning";
        //   }
          return (
            <div className="col-sm-12 col-md-12" key={index}>
              <div className="card">
                <div className="card-header card_header_bg" value={item.id}>
                  <a
                    className="pointer_class"
                    id={item.chapter_name}
                    value={item.id}
                    onClick={this._getReadings.bind(this, item)}
                  >
                      {language.LC().TOPIC} {item.chapter_no} - {item.chapter_name}
                  </a>
                </div>
                <div
                  className="card-block list_icon_outer"
                  key={item.chapter_name}
                >
                  {item.Countvideos > 0 ? (
                    <p>
                      {language.LC().TOTAL_VIDEOS}: {item.Countvideos}
                    </p>
                  ) : (
                    <p />
                  )}
                  <div key={index} className="col-xs-12 col-sm-12 col-md-12">
                    <ChatperwiseReadingData
                      key={item.id}
                      item={item}
                      showFreePremium={this.state.showFreePremium}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        // }
        // else {
        //   return null;
        // }
      });
    } else {
      data = <Loader />;
    }
    return (
      <div className="video_lesson_wrap">
        <div className="animated fadeIn">
          <div className="margin_bottom_20 d-flex justify-content-between last_question_read">
            <h1 className="section_head"> {language.LC().VIDEO_LESSONS} </h1>

            {lastAttempt ? (
              <button
                className="btn btn-primary pointer_class"
                onClick={this.goToVideo.bind(this)}
                disabled={!lastAttempt}
              >
                {" "}
                {language.LC().GO_TO_MY_LAST_VIDEO_VIEWED}{" "}
              </button>
            ) : null}
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12">
              <div className="bank_wrapper">
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    <div className="card" />
                  </div>
                  {data}
                </div>
              </div>
            </div>
          </div>

          <ModalComponent
            goPremium={this.goPremium.bind(this)}
            toggleAlert={this.toggleAlert.bind(this)}
            alert_status={this.state.alert_status}
            MessageContent={this.state.MessageContent}
          />
        </div>
      </div>
    );
  }
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <img onClick={onClick} src="../../assets/img/right-arrow.svg" alt="" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        fontSize: "60px",
        right: "80px",
        zIndex: "15",
        height: "20px",
        width: "40px",
        opacity: "1",
      }}
      onClick={onClick}
    >
      <img onClick={onClick} src="../../assets/img/left-arrow.svg" alt="" />
    </div>
  );
}

export default GMATVideoLessons;



// WEBPACK FOOTER //
// ./src/views/EA-Exams/VideoLessons/VideoLessons.js